module.exports = __webpack_public_path__ + "img/video_off.0f39033b.svg";